module.exports = __webpack_public_path__ + "img/sup_kyc_11.b90f7f29.jpg";